import styled from 'styled-components'
import { space } from 'styled-system'
import { VehiclesProps } from './Vehicles'

export const StyledVehicles = styled.div<VehiclesProps>`
  display: flex;
  flex-wrap: ${props => (props.variant !== 'alternative' ? 'wrap' : 'no-wrap')};
  ${props => props.variant === 'alternative' && 'flex-direction: column'};
  justify-content: flex-start;
  width: ${props => (props?.fullWidth ? '100%' : 'auto')};
  ${space}

  & > section {
    margin-bottom: ${props => props.theme.spacing.medium};
    margin-top: auto;

    &:not(:last-of-type) {
      margin-right: ${props => props.theme.spacing.default};
    }
  }
`
